import axios from "axios";
import instance from "../../../../axios";

export const BASEV2_URL = `${process.env.REACT_APP_API_URL_V2}`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const LOCAL_URL = `${process.env.REACT_APP_API_URL_LOCAL}`;

export function getAdsListList(queryParams, coinStoresForEdit) {
  const headers = {
    "company-code": "gj", // You can keep this as it is if it's a fixed value
    // Include the companyId in the request headers
    "company-id": coinStoresForEdit?.item?._id,
  };
  console.log("gdhsbsdbfsdfbsdf", coinStoresForEdit?.data[0]?.param?._id);
  return instance
    .post(
      `${BASEV2_URL}/adDownload/adsList/${coinStoresForEdit?.data[0]?.param?._id}`,
      {
        pagination: {
          pageNo: parseInt(queryParams.page) ? parseInt(queryParams.page) : 1,
          recordPerPage: parseInt(queryParams.limit)
            ? parseInt(queryParams.limit)
            : 10,
          sortBy: queryParams.sortBy,
          sortDirection: queryParams.sort,
        },
        search: queryParams?.search,
      },
      { headers }
    )
    .then((res) => {
      return res;
    });
}

export function getItemById(id) {
  return instance.get(`${BASEV2_URL}/adDownload/getCompanyByID/${id}`);
}
//scrim view
export function getContestDetails(queryParams) {
  return instance
    .get(`${BASEV2_URL}/scrim/getScrimBasicDetails/${queryParams}`)
    .then((res) => {
      return res;
    });
}

//rules
export function getRules(id) {
  return instance.get(`${BASEV2_URL}/scrim/getScrimRules/${id}`).then((res) => {
    return res;
  });
}

export function getScreenshot(id) {
  return instance.get(`${BASEV2_URL}/scrim/getSSDetails/${id}`).then((res) => {
    return res;
  });
}
export function getAllGamesList(queryParams) {
  // console.log('queryParams WEWEWE:', queryParams)
  return instance
    .post(`${BASE_URL}/game/list`, {
      pagination: {
        pageNo: parseInt(queryParams?.page || 1),
        recordPerPage: parseInt(queryParams?.limit || 1000),
        sortBy: "name",
        sortDirection: "asc",
      },
      search: queryParams?.search,
    })
    .then((res) => {
      return res;
    });
}

export function getGameTypeList(queryParams) {
  return instance.post(`${BASE_URL}/gameType/list`, queryParams).then((res) => {
    return res;
  });
}

export function getContestUsersList(id) {
  return instance
    .post(`${BASEV2_URL}/scrim/getScrimJoinedUser/${id}`)
    .then((res) => {
      return res;
    });
}

export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/country/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function getcurrency(queryParams) {
  return instance
    .post(`${BASE_URL}/currency/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export function saveScreenShotImage(queryParams) {
  let localUrl = "http://localhost:9155/api";
  // console.log(queryParams.screenshotImages)
  let ss = {};
  ss.screenshotImages = queryParams.screenshotImages;
  // let ss = queryParams.screenshotImages
  return instance
    .post(`${BASE_URL}/contest/screenshotImage/save/${queryParams.id}`, ss)
    .then((res) => {
      return res;
    });
}
export function fetchCountriesList(queryParams) {
  return instance.post(`${BASE_URL}/country/list`, queryParams).then((res) => {
    return res;
  });
}

export function fetchCountriesDropdownList(queryParams) {
  return instance
    .post(`${BASE_URL}/country/Dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}
